<template>
    <ValidationObserver ref="validationObserver" slim>
        <div>
            <ErrorLogShower />
            <Progressbar processType="SnA" :currentStepIndex="2" v-if="ProgressbarVisible" @clickstep1="backToStep1" @clickstep2="back" />

            <div class="contentblock">
                <section class="contentblock__content">

                    <div class="shop__fieldgroup shop__fieldgroup--no-separator shop__fieldgroup--no-padding-bottom">
                        <h3 class="shop__fieldgroup-title shop__fieldgroup-title--big">{{Title}}</h3>
                    </div>

                    <div class="shop__fieldgroup" :class="{'shop__fieldgroup--no-separator': PricesAvailable}">
                        <div class="shop__position-review">
                            <div class="shop__position-review-address">
                                <div class="shop__position-review-address-details">
                                    <AddressReadonly :address="CurrentPosition.warenempfaenger"
                                                     :showPhone="true"
                                                     :showEmail="false"
                                                     :showCumulus="false"
                                                     :label="Strings['Shop.DeliveryAddress_SnA']" />
                                    <AddressReadonly :address="CurrentPosition.regulierer !== null ? CurrentPosition.regulierer : CurrentTransaction.auftraggeber"
                                                     :showPhone="false"
                                                     :showEmail="false"
                                                     :showCumulus="true"
                                                     :label="Strings['Shop.BillingAddress']" />
                                </div>
                            </div>
                            <div class="shop__position-review-product">
                                <PositionProductAndPriceInfo :position="CurrentPosition" />
                            </div>
                        </div>
                    </div>

                    <div class="shop__position-review-total" v-if="PricesAvailable">
                        <div class="shop__fieldgroup shop__fieldgroup--no-separator shop__fieldgroup--no-padding-bottom shop__fieldgroup--no-padding-top">
                            <div class="shop__position-review">
                                <div class="shop__position-review-address">
                                </div>
                                <div class="shop__position-review-product" style="text-align: center; margin-top: 0">
                                    <strong>{{Strings['Shop.Total']}}: {{CurrentTransaction.material.getTotalPrice(null)|formatPrice}}</strong><br />
                                    <small>{{Strings['Shop.InclTax']}}</small>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="shop__fieldgroup">
                        <h3 class="shop__fieldgroup-title">{{Strings['Shop.TitleEquipment']}}</h3>
                        <div class="shop__options-block" style="margin-bottom: 0">
                            <div class="shop__options-block-input shop__address-readonly-block">
                                <div class="shop__address-readonly-label">{{Strings['Shop.LabelBoilerSize']}}:</div>
                                {{CurrentEquipment.size|formatAmount}} {{Strings['Shop.UnitsLiter']}}
                            </div>
                        </div>
                    </div>

                    <div class="shop__fieldgroup">
                        <h3 class="shop__fieldgroup-title">{{Strings['Shop.LabelDeliveryPeriod']}}</h3>
                        <DeliveryPeriodReadOnly mode="SnA" />
                    </div>

                    <div class="shop__fieldgroup" v-if="ShowDiscountCode">
                        <h3 class="shop__fieldgroup-title">{{Strings['Shop.Options']}}</h3>
                        <div class="shop__options-block">
                            <div class="shop__options-block-input">
                                {{Strings['Shop.LabelDiscountCode']}}
                            </div>
                            <div class="shop__options-block-desc">
                                <div>
                                    <span class="shop__address-readonly-label">{{CurrentTransaction.discountCode}}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="shop__fieldgroup">
                        <h3 class="shop__fieldgroup-title">{{Strings['Shop.Auftraggeber']}}</h3>
                        <AddressReadonly :address="CurrentTransaction.auftraggeber"
                                         :showPhone="true"
                                         :showEmail="true"
                                         :showCumulus="false"
                                         layout="two-cols" />
                    </div>

                    <div class="shop__fieldgroup shop__fieldgroup--no-separator">
                        <div class="shop__acceptance-checkbox" v-if="!IsOrder">
                            <NewsletterCheckbox />
                        </div>
                        <div class="shop__acceptance-checkbox" v-if="IsOrder">
                            <AGB v-model="agbAccepted" product="Boilerentkalkung" />
                        </div>
                        <div class="shop__acceptance-checkbox">
                            <DSE v-model="dseAccepted" />
                        </div>
                    </div>

                    <OfferAndOrderErrors />

                    <div class="migrol-form__buttons">
                        <AjaxButton :isWaitingForAjax="isWaitingForAjax" :label="Strings['Shop.ButtonBack']" v-if="BackButtonVisible" v-show="!isWaitingForAjax" @buttonClick="back" />
                        <AjaxButton :isWaitingForAjax="isWaitingForAjax" :label="NextButtonText" cssclass="migrol-form__button--green" @buttonClick="forward" />
                    </div>

                </section>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
    import { mapState, mapActions, mapGetters } from 'vuex';
    import { ValidationObserver } from 'VeeValidate'
    import Progressbar from '../_common/Progressbar'
    import ErrorLogShower from '../_common/ErrorLogShower'
    import NewsletterCheckbox from '../_common/NewsletterCheckbox'
    import PositionProductAndPriceInfo from '@/components/_common/PositionProductAndPriceInfo'
    import DeliveryPeriodReadOnly from '@/components/_common/DeliveryPeriodReadOnly'
    import OfferAndOrderErrors from '../_common/OfferAndOrderErrors'
    import { doValidation, stepBeforeRouteLeave } from '@/utils/utils'
    import { CreateOfferOutcomes, CreateOrderOutcomes } from '@/utils/constants';

    import Transaction from '@/models/Transaction';
    import Price from '@/models/Price';

    export default {
        props: {
            stepMode: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                agb: false,
                dse: false
            }
        },
        computed: {
            ...mapState([
                'Strings',
                'Enums'
            ]),
            ...mapGetters([
                'isWaitingForAjax'
            ]),
            CurrentTransaction() {
                return Transaction.query().with(['auftraggeber', 'positions.warenempfaenger|regulierer|equipment', 'material', 'deliveryPeriod']).first();
            },
            CurrentPosition() {
                return this.CurrentTransaction.positions[0];
            },
            CurrentEquipment() {
                return this.CurrentPosition.equipment;
            },
            PricesAvailable() {
                return Price.query().count() > 0;
            },
            Title() {
                switch (this.stepMode) {
                    case 'offer':
                        return this.Strings['Shop.OfferSummary'];
                    case 'order':
                        return this.Strings['Shop.OrderSummary'];
                    default:
                        throw 'Invalid stepMode ' + this.stepMode;
                }
            },
            IsOrder() {
                return this.stepMode === 'order';
            },
            ShowDiscountCode() {
                //show only if coupon is available, hide for multiple UP, campaigns, and partner links
                return this.CurrentTransaction.discountCode != null && this.CurrentTransaction.discountCode != '' && this.CurrentTransaction.positions.length == 1 && !this.CurrentTransaction.isCampaignOffer && !this.IsPartnerLink;
            },
            ProgressbarVisible() {
                //hide progressbar for orders made on an offer
                return this.CurrentTransaction.offerId === null;
            },
            BackButtonVisible() {
                //hide back button for orders made on an offer
                return this.CurrentTransaction.offerId === null;
            },
            NextButtonText() {
                if (this.IsOrder) {
                    return this.Strings['Shop.ButtonCreateOrderNow'];
                } else {
                    return this.Strings['Shop.ButtonCreateOfferNow'];
                }
            },
            AllowedNavigationPaths() {
                let paths = [];

                if (!this.IsOrderOnOffer) {
                    //allow back to step 1
                    paths.push({ path: '/', requiresValidation: false });
                    //allow back to step 2
                    paths.push({ path: '/equipment', requiresValidation: false });
                }

                //forward to confirmation
                paths.push({ path: '/' + this.stepMode + '-confirmation', requiresValidation: true });

                return paths;
            },
            agbAccepted: {
                get() { return this.CurrentTransaction.agbAccepted; },
                set(val) { this.CurrentTransaction.$update({ agbAccepted: val }); }
            },
            dseAccepted: {
                get() { return this.CurrentTransaction.dseAccepted; },
                set(val) { this.CurrentTransaction.$update({ dseAccepted: val }); }
            }
        },
        methods: {
            ...mapActions([
                'MakeOffer',
                'MakeOrder'
            ]),
            back() {
                this.$router.push('/equipment').catch(() => { });
            },
            backToStep1() {
                this.$router.push('/').catch(() => { });
            },
            async forward() {

                var vm = this;

                doValidation(vm.$refs.validationObserver, () => {

                    if (vm.IsOrder) {
                        vm.MakeOrder()
                            .then((result) => {
                                if (result != null) {
                                    if (result.Outcome == CreateOrderOutcomes.AutomaticOrder || result.Outcome == CreateOrderOutcomes.Interaktionsformular) {
                                        vm.$router.push('/order-confirmation').catch(() => { });
                                    }
                                } else {
                                    //if result is null, the request sequence number was off.
                                    console.error('MakeOrder: sequence number mismatch.');
                                }
                            })
                            .catch((error) => {
                                //this happens, when the ajax request failed somehow (500 error etc.)
                                console.error(error);
                            });
                    } else {
                        vm.MakeOffer()
                            .then((result) => {
                                if (result != null) {
                                    if (result.Outcome == CreateOfferOutcomes.AutomaticOffer || result.Outcome == CreateOfferOutcomes.Interaktionsformular) {
                                        vm.$router.push('/offer-confirmation').catch(() => { });
                                    }
                                } else {
                                    //if result is null, the request sequence number was off.
                                    console.error('MakeOffer: sequence number mismatch.');
                                }
                            })
                            .catch((error) => {
                                //this happens, when the ajax request failed somehow (500 error etc.)
                                console.error(error);
                            });
                    }
                });
            }
        },
        mounted() {
            if (window.dataLayer) {

                window.dataLayer.push({
                    'event': 'checkoutOption',
                    'ecommerce': {
                        'checkout_option': {
                            'actionField': { 'step': 2, 'option': this.CurrentTransaction.deliveryPeriod.displayText }
                        }
                    }
                });

                window.dataLayer.push({
                    event: 'add_shipping_info',
                    shipping_tier: this.CurrentTransaction.deliveryPeriod.displayText,
                    quantity: 1,
                    zip: this.CurrentTransaction.positions[0].warenempfaenger.zipcode.toString(),
                    ecommerce: {
                        shipping_tier: this.CurrentTransaction.deliveryPeriod.displayText, // Information �ber Lieferung - Termininformationen
                        items: [{
                            item_name: 'Boilerentkalkung', // Produktname in Shopsprache - Heiz�l, Holzpellets, Diesel
                            item_id: this.CurrentTransaction.material.materialNumber, // �bergeordnete ID f�r Heiz�l, Holzpellets, Diesel da Variante des Produktes noch nicht vorhanden - wenn nicht vorhanden leer
                            price: this.CurrentTransaction.material.getTotalPrice(null), // Preis per Liter
                            item_brand: 'migrol', // Brand des Produktes - falls nicht vorhanden 'migrol'
                            item_category: 'boilerentkalkung', // z.B.: Heiz�l, Holzpellets, Diesel
                            item_variant: this.CurrentTransaction.material.name, // Produktvariant, wenn vorhanden (zB.: gelb) Varaint der Produkte erst im Checkout Steps ausw�hlbar - Bitte leer lassen
                            quantity: 1 // Menge
                        }]
                    }
                });
            }
        },
        beforeRouteLeave(to, from, next) {
            stepBeforeRouteLeave(this.AllowedNavigationPaths, this.$refs.validationObserver, to, next);
        },
        components: {
            ValidationObserver,
            ErrorLogShower,
            PositionProductAndPriceInfo,
            Progressbar,
            DeliveryPeriodReadOnly,
            OfferAndOrderErrors,
            NewsletterCheckbox
        }
    };
</script>